// Module-level shared bits for BookingsTab. Kept OUT of the component body so
// their identity is stable across parent re-renders (React would otherwise
// unmount/remount their inputs on every keystroke, stealing focus).

export const FilterTab = ({ id, label, count, active, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={`bookings-filter-${id}`}
    className={`px-3 py-1.5 rounded-full text-xs font-medium border transition-all lift whitespace-nowrap ${active ? "bg-primary text-primary-foreground border-primary" : "bg-card text-muted-foreground border-border hover:border-primary/40"}`}
  >
    {label} <span className="ml-1 text-[10px] opacity-70">· {count}</span>
  </button>
);

export const OtaField = ({ label, children, testid }) => (
  <div className="grid grid-cols-[140px_1fr] gap-3 py-2 border-b border-border/40 last:border-0 items-center" data-testid={testid}>
    <div className="text-[11px] uppercase tracking-widest text-muted-foreground">{label}</div>
    <div>{children}</div>
  </div>
);
